import { MasterConfigs } from "../../../../interfaces/entity";

export const DottedLineManagerConfig: MasterConfigs = {
    api: () => '/dottedlinemanager',
    title: 'Dotted Line Manager',
    isActionTab: true,
    modalTitle: (action) => `${action} ${DottedLineManagerConfig.title}`,
    getFormColumns: () => {
        return [
            {
                name: 'departmentWall',
                type: 'checkboxGroup',
                span: 24,
                children: [
                    {
                        name: 'Enable Dotted Line Manager',
                        value: 'enableDottedLineManager'
                    }
                ]
            }
        ];
    },
    combo: [],
    getData: () => ({}),
    actions: [],
};
